(() => {
  angular
    .module('gm.common.services')
    .factory('GmyCookies', GmyCookies);

  function GmyCookies(
    $log,
    ipCookie
  ) {
    'ngInject';

    return {
      get,
      remove,
      set,
    };

    function get(key) {
      try {
        return ipCookie(key);
      } catch (e) {
        $log.error('Cookies not supported');
      }
      return false;
    }

    function remove(key, options) {
      try {
        ipCookie.remove(key, options);
      } catch (e) {
        $log.error('Cookies not supported');
      }
    }

    function set(key, value, options) {
      try {
        return ipCookie(key, value, options);
      } catch (e) {
        $log.error('Cookies not supported');
      }
      return false;
    }
  }
})();
